import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'

import Layout from '../../layouts/layout'
// import Hero from '../components/hero'

const RecruitingStrategiesPage = ({ data }) => {
  return (
    <Layout>
      <Helmet
        title={'Recruiting Strategies | ' + data.siteTitle.siteMetadata.title}
        meta={[
          { name: 'description', content: 'Recruiting Strategies overriding description but not keywords.' }
        ]}
      />
      <div style={{margin: '90px auto', maxWidth: '92%'}}>
        <h1>Recruiting Strategies</h1>
        <p>Welcome to the recruiting-strategies page.</p>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    siteTitle: site {
      siteMetadata {
        title
      }
    }
  }
`

export default RecruitingStrategiesPage
